import { render, staticRenderFns } from "./FButton.vue?vue&type=template&id=2b702646&"
import script from "./FButton.vue?vue&type=script&lang=js&"
export * from "./FButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports